import { MealTime } from "@/clients/models/MealTime";
import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { useLifeStyle } from "@/features/lifestyle/hooks/use-lifestyle";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import LifestyleSelectionList from "../../components/lifestyle-selection-list";

/**
 * Onboarding page for collecting user's snack preferences.
 * Allows users to select their preferred snack options to help tailor their meal plan.
 */
export default function OnboardingSnack() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();

  // Use the lifestyle hook to manage snack preferences
  const {
    selectedPreference,
    handlePreferenceSelect,
    handleSubmit,
    isUpdating,
    options,
    isLoading,
  } = useLifeStyle(MealTime.SNACK, () => {
    // Navigate to the next step after successful submission
    navigation.push(info?.nextPath ?? "", "none");
  });

  return (
    <ProfilePageContainer>
      {/* Page title and description */}
      <PageTitleComponent
        title="What about snacks?"
        description="Select your preferred snack options. We'll tailor your plan to match your snacking habits."
        className="mt-2 mb-6 w-full"
      />

      {/* List of snack preference options */}
      <LifestyleSelectionList
        isLoading={isLoading}
        options={options?.lifestyleOptionsData ?? []}
        selectedPreference={selectedPreference}
        handlePreferenceSelect={handlePreferenceSelect}
      />

      {/* Navigation buttons - back and next */}
      <StepsButtons
        previousPath={info?.previousPath}
        type="button"
        disabled={isUpdating}
        onClick={handleSubmit}
      />
    </ProfilePageContainer>
  );
}
